// Panel tarjimasi (3/3): ruscha. Kalit — o'zbekcha matn.
const lugat = {
  // --- Yangiliklar ---
  "Yangilik": "Новость",
  "E'lon": "Объявление",
  "Tadbir": "Мероприятие",
  "Buyruq": "Приказ",
  "Video yuklanmadi. Qayta urinib ko'ring.": "Видео не загружено. Попробуйте ещё раз.",
  "Sarlavha *": "Заголовок *",
  "Turi: Matn": "Тип: Текст",
  "Turi: Video": "Тип: Видео",
  "Kompyuterdan video yuklash": "Загрузить видео с компьютера",
  "Yuklanmoqda... {progress}%": "Загрузка... {progress}%",
  "Server faylni qabul qilmoqda...": "Сервер принимает файл...",
  "Fayl yuklangach havola quyida o'zi paydo bo'ladi. Eng ko'pi 500 MB (mp4, mov, webm, mkv, avi).": "После загрузки ссылка появится ниже автоматически. Максимум 500 МБ (mp4, mov, webm, mkv, avi).",
  "Video havolasi * (yuklasangiz o'zi to'ladi, yoki YouTube havolasi)": "Ссылка на видео * (заполнится сама после загрузки, или ссылка YouTube)",
  "Yoki tashqi havola: https://www.youtube.com/watch?v=...": "Или внешняя ссылка: https://www.youtube.com/watch?v=...",
  "Video tavsifi (ixtiyoriy)": "Описание видео (необязательно)",
  "Yangilik matni *": "Текст новости *",
  "Sarlavha kiriting": "Введите заголовок",
  "Video uchun havola kiriting": "Введите ссылку на видео",
  "Yangilik matnini kiriting": "Введите текст новости",
  "Yangilik qo'shilmadi.": "Новость не добавлена.",
  "Yangi yangilik": "Новая новость",
  "Video yuklanmoqda...": "Видео загружается...",
  "Joylash": "Опубликовать",
  "Sarlavha": "Заголовок",
  "Kategoriya": "Категория",
  "havola ↗": "ссылка ↗",
  "▶ Video": "▶ Видео",
  "📄 Matn": "📄 Текст",
  "Hali yangilik joylanmagan.": "Новостей пока нет.",
  "Yangilikni tahrirlash": "Редактирование новости",

  // --- Eslatmalar ---
  "Sarlavha * (masalan: Kunlik eslatma)": "Заголовок * (например: Ежедневное напоминание)",
  "Ovoz: {s}": "Звук: {s}",
  "Ovoz: telefon standarti": "Звук: стандартный телефона",
  "Bildirishnoma matni *": "Текст уведомления *",
  "Faol (o'chirilsa xodimlarga bormaydi)": "Активно (если выключить, сотрудникам не придёт)",
  "Vaqtni tanlang": "Выберите время",
  "Bildirishnoma matnini kiriting": "Введите текст уведомления",
  "{time} uchun eslatma qo'shildi.": "Напоминание на {time} добавлено.",
  "Eslatma qo'shilmadi.": "Напоминание не добавлено.",
  "Eslatma yangilandi.": "Напоминание обновлено.",
  "Amal bajarilmadi.": "Действие не выполнено.",
  "{time} — \"{title}\" eslatmasi o'chirilsinmi?": "Удалить напоминание {time} — «{title}»?",
  "Eslatma o'chirildi.": "Напоминание удалено.",
  "Kunlik eslatmalar": "Ежедневные напоминания",
  "Belgilangan vaqtlarda xodimlar telefoniga bildirishnoma boradi. Hozir": "В назначенное время на телефоны сотрудников приходит уведомление. Активных напоминаний сейчас:",
  "{activeCount} ta": "{activeCount}",
  "faol eslatma bor.": "",
  "Yangi eslatma": "Новое напоминание",
  "Sarlavha va matn": "Заголовок и текст",
  "Ovoz": "Звук",
  "standart": "стандартный",
  "Yoqish": "Включить",
  "Hali eslatma qo'shilmagan.": "Напоминаний пока нет.",
  "Eslatmalar xodim telefonining o'zida rejalashtiriladi — internet bo'lmasa ham keladi. Vaqtni o'zgartirsangiz, xodim ilovani keyingi ochganda yangi jadval qo'llanadi.": "Напоминания планируются на самом телефоне сотрудника — приходят даже без интернета. Если изменить время, новое расписание применится при следующем открытии приложения.",
  "Eslatmani tahrirlash": "Редактирование напоминания",

  // --- Sayyor sud ---
  "Rejalashtirilgan": "Запланирован",
  "O'tkazildi": "Проведён",
  "Bekor qilingan": "Отменён",
  "Ro'yxatni olishda xato": "Ошибка загрузки списка",
  "Sayyor sud belgilandi — {sanaMatni}": "Выездной суд назначен — {sanaMatni}",
  "Ochishda xato": "Ошибка открытия",
  "Qo'shishda xato": "Ошибка добавления",
  "\"{nomi}\" bekor qilinsinmi?\n\n": "Отменить «{nomi}»?\n\n",
  "Yozuv o'chirilmaydi — holati \"bekor qilingan\" bo'ladi.": "Запись не удаляется — её статус станет «отменён».",
  "Bekor qilindi": "Отменено",
  "📋 Rejalash": "📋 Планирование",
  "📅 Ro'yxat": "📅 Список",
  "Yangi sayyor sud": "Новый выездной суд",
  "Sud nomi / mavzu *": "Название суда / тема *",
  "Probatsiya nazorati yig'ilishi": "Заседание по контролю пробации",
  "Sana *": "Дата *",
  "Hujjat raqami": "Номер документа",
  "Bino / joy": "Здание / место",
  "Tuman hokimligi, majlis zali": "Хокимият района, зал заседаний",
  "Probatsiya inspektori (telefonda shu sudni u ko'radi)": "Инспектор пробации (он увидит этот суд в телефоне)",
  "tanlang —": "выберите —",
  "Xodim ID raqami": "ID сотрудника",
  "Rasmiy ishtirokchilar": "Официальные участники",
  "Sudya": "Судья",
  "Kotib": "Секретарь",
  "Sud maqsadi": "Цель заседания",
  "Mahkumlarning probatsiya muddati va xulq-atvorini muhokama qilish": "Обсуждение срока пробации и поведения осуждённых",
  "Mahkumlar sud belgilangandan keyin, «Ro'yxat» bo'limida qo'shiladi.": "Осуждённые добавляются после назначения суда, в разделе «Список».",
  "📅 Sud belgilash": "📅 Назначить суд",
  "Tozalash": "Очистить",
  "Hali sayyor sud belgilanmagan": "Выездных судов пока нет",
  "{slice}-oy": "мес. {slice}",
  "joy ko'rsatilmagan": "место не указано",
  "{mahkumlar_soni} mahkum": "осуждённых: {mahkumlar_soni}",
  "{foto_soni} foto": "фото: {foto_soni}",
  "GPS tasdiqlangan": "GPS подтверждён",
  "Orqaga": "Назад",
  "Inspektor": "Инспектор",
  "Yakunlangan.": "Завершён.",
  "{foto_soni} ta fotosurat olingan": "Сделано фото: {foto_soni}",
  " · GPS: {toFixed}, {toFixed2}": " · GPS: {toFixed}, {toFixed2}",
  " · GPS qayd etilmagan": " · GPS не зафиксирован",
  "Ko'rib chiqiladigan mahkumlar": "Рассматриваемые осуждённые",
  "mahkum qo'shish —": "добавить осуждённого —",
  "Avval «Mahkumlar» bo'limiga yozuv qo'shing": "Сначала добавьте запись в раздел «Осуждённые»",
  "Ro'yxat bo'sh": "Список пуст",
  "Sud qarori": "Решение суда",

  // --- SOS ---
  "{n} soniya oldin": "{n} сек назад",
  "{n} daqiqa oldin": "{n} мин назад",
  "Signallarni olishda xato": "Ошибка загрузки сигналов",
  "Qabul qilinmadi.": "Не принято.",
  "Signal yopilsinmi? Xodimga yordam yetganiga ishonch hosil qiling.": "Закрыть сигнал? Убедитесь, что помощь сотруднику оказана.",
  "Yopilmadi.": "Не закрыто.",
  "✅ Qabul qildi": "✅ Принял",
  "🚗 Yo'lda": "🚗 В пути",
  "⏹️ Yopildi": "⏹️ Закрыт",
  "⏳ Kutilmoqda": "⏳ Ожидание",
  "Xizmat raqami:": "Служебный номер:",
  "tuman ko'rsatilmagan": "район не указан",
  "Xaritada ochish": "Открыть на карте",
  "Joylashuv aniqlanmadi": "Местоположение не определено",
  "{nom} — qabul qildim": "{nom} — принял",
  "⏹️ Signalni yopish": "⏹️ Закрыть сигнал",
  "Yopilgan: {vaqtMatni}": "Закрыт: {vaqtMatni}",
  "Ro'yxat har 10 soniyada o'zidan yangilanadi": "Список обновляется автоматически каждые 10 секунд",
  "Yangi signal keldi — bosib o'chiring": "Пришёл новый сигнал — нажмите, чтобы выключить звук",
  "Hammasini ko'rsatish": "Показать все",
  "Faqat ochiqlari": "Только открытые",
  "Signal yo'q.": "Сигналов нет.",
  "Ochiq signallar ({soni})": "Открытые сигналы ({soni})",
  "Yopilganlar ({soni})": "Закрытые ({soni})",

  // --- Taqdimnoma ---
  "Taqdimnoma turlari": "Виды представлений",
  "Har bir tur — tayyor shablon. Xodim ilovada turni tanlaydi, matn shu yerdan tushadi. Matnlarni normativ hujjatdan aynan ko'chirib qo'ying.": "Каждый вид — готовый шаблон. Сотрудник выбирает вид в приложении, текст берётся отсюда. Копируйте тексты из нормативного документа дословно.",
  "Qisqa nomi": "Краткое название",
  "To'liq nomi": "Полное название",
  "Modda": "Статья",
  "Kalit (ilova shu bo'yicha taniydi, o'zgartirmang)": "Ключ (приложение распознаёт по нему, не меняйте)",
  "Qisqa nomi — ilovadagi tugmada ko'rinadi": "Краткое название — отображается на кнопке в приложении",
  "Modda raqami": "Номер статьи",
  "Tartib raqami": "Порядковый номер",
  "Mavzu satri — \"T A Q D I M N O M A\" sarlavhasi ustida turadi": "Строка темы — располагается над заголовком «П Р Е Д С Т А В Л Е Н И Е»",
  "1-xatboshi — mahkumning shaxsi": "Абзац 1 — личность осуждённого",
  "2-xatboshi — hukm": "Абзац 2 — приговор",
  "3-xatboshi — probatsiyaga qabul qilinishi": "Абзац 3 — принятие на пробацию",
  "Qonun iqtibosi — hujjatdagi ramkali qism": "Цитата закона — часть документа в рамке",
  "Oxirgi xatboshi — suddan so'rov": "Последний абзац — ходатайство в суд",
  "Tuman IIB lari": "Районные ОВД",
  "Hujjat blankidagi o'zgarmas ma'lumotlar: nomi, manzili, telefoni va imzo qo'yadigan boshliq.": "Постоянные данные бланка: название, адрес, телефон и начальник, который подписывает.",
  "Boshlig'i": "Начальник",
  "IIB nomi": "Название ОВД",
  "Manzili — blankda ko'rinadi": "Адрес — отображается на бланке",
  "Telefoni": "Телефон",
  "Hujjat raqami seriyasi (masalan: 56/30)": "Серия номера документа (например: 56/30)",
  "Boshliq unvoni": "Звание начальника",
  "Boshliq ismi (qisqartma)": "Имя начальника (сокращённо)",
  "Sudlar": "Суды",
  "Taqdimnoma kimga yuboriladi. Hujjatning o'ng yuqori burchagida uch qator bo'lib chiqadi.": "Кому направляется представление. Выводится тремя строками в правом верхнем углу документа.",
  "Raisi": "Председатель",
  "Murojaat satri (masalan: Jinoyat ishlari bo'yicha ... sudi raisi)": "Строка обращения (например: Председателю суда по уголовным делам ...)",
  "Raisi (jo'nalish kelishigida: ...ga)": "Председатель (в дательном падеже: ...у)",
  "\"{l}\" to'ldirilishi shart": "Поле «{l}» обязательно",
  "Qo'shildi.": "Добавлено.",
  "Saqlandi.": "Сохранено.",
  "\"{nom}\" ro'yxatdan olib tashlansinmi?": "Убрать «{nom}» из списка?",
  "O'chirildi.": "Удалено.",
  "Xodim ilovada taqdimnoma to'ldirganda turni, IIB va sudni shu ro'yxatlardan tanlaydi, matn esa shu yerdagi shablondan tushadi.": "Заполняя представление в приложении, сотрудник выбирает вид, ОВД и суд из этих списков, а текст берётся из шаблона здесь.",
  "Mahkum ma'lumoti serverda saqlanmaydi": "Данные осуждённого на сервере не хранятся",
  "xodim uni har safar qo'lda yozadi.": "сотрудник каждый раз вводит их вручную.",
  "Qaydlar jurnali": "Журнал записей",
  "Chiqarilgan taqdimnomalar": "Выданные представления",
  "Mahkumning ismi va boshqa ma'lumoti bu yerda yo'q — faqat kim, qachon va qaysi tur bo'yicha chiqargani.": "Имени и других данных осуждённого здесь нет — только кто, когда и по какому виду выдал.",
  "Raqami": "Номер",
  "Sud": "Суд",
  "Hali taqdimnoma chiqarilmagan.": "Представлений пока не выдавалось.",
  "Matni to'ldirilmagan — ilovada bo'sh hujjat chiqadi": "Текст не заполнен — в приложении получится пустой документ",
  "Ro'yxat bo'sh. Ilovada xodim tanlay olishi uchun kamida bitta yozuv kerak.": "Список пуст. Чтобы сотрудник мог выбрать в приложении, нужна хотя бы одна запись.",
  "Yangi — {nom}": "Новая запись — {nom}",
  "Matn ichiga shu belgilarni qo'ying — ilova ularni xodim kiritgan qiymat bilan almashtiradi:": "Вставьте в текст эти метки — приложение заменит их значениями, введёнными сотрудником:",

  // --- Testlar ---
  "Savollar ({soni})": "Вопросы ({soni})",
  "Savol qo'shish": "Добавить вопрос",
  "savol": "вопрос",
  "Savol matni": "Текст вопроса",
  "To'g'ri javob": "Правильный ответ",
  "To'g'ri javob deb belgilash": "Отметить как правильный",
  "{toUpperCase} varianti": "Вариант {toUpperCase}",
  "Yashil bilan belgilangan variant — to'g'ri javob.": "Вариант, отмеченный зелёным, — правильный ответ.",
  "Kamida bitta savol qo'shing — savolsiz test ilovada ochilmaydi": "Добавьте хотя бы один вопрос — тест без вопросов в приложении не откроется",
  "{n}-savol to'liq to'ldirilmagan (savol matni va 4 ta variant)": "Вопрос {n} заполнен не полностью (текст вопроса и 4 варианта)",
  "Korrupsiyaga qarshi": "Противодействие коррупции",
  "Yo'l xavfsizligi": "Безопасность дорожного движения",
  "Kasbiy etika": "Профессиональная этика",
  "Psixologiya": "Психология",
  "Test nomi va kategoriyani tanlang": "Укажите название теста и категорию",
  "\"{title}\" yaratildi — {question_count} ta savol bilan.": "«{title}» создан — вопросов: {question_count}.",
  "Test yaratilmadi. Qaytadan urinib ko'ring.": "Тест не создан. Попробуйте ещё раз.",
  "Testni yuklab bo'lmadi.": "Не удалось загрузить тест.",
  "\"{title}\" yangilandi — {question_count} ta savol.": "«{title}» обновлён — вопросов: {question_count}.",
  "Saqlanmadi. Qaytadan urinib ko'ring.": "Не сохранено. Попробуйте ещё раз.",
  "DIQQAT: bu testni {n} ta xodim topshirgan. Ularning natijalari ham o'chadi.": "ВНИМАНИЕ: этот тест прошли {n} сотрудников. Их результаты тоже удалятся.",
  "\"{title}\" o'chirilsinmi?{warning}\n\nBu amalni qaytarib bo'lmaydi.": "Удалить «{title}»?{warning}\n\nЭто действие нельзя отменить.",
  "Yangi test": "Новый тест",
  "Test nomi": "Название теста",
  "Kategoriya tanlang": "Выберите категорию",
  "Yaratilmoqda...": "Создание...",
  "Testni yaratish": "Создать тест",
  "Savollar": "Вопросы",
  "Topshirilgan": "Пройдено",
  "bo'sh": "пусто",
  "Hali test yaratilmagan.": "Тестов пока нет.",
  "Testni tahrirlash": "Редактирование теста",
  "Bu testni {result_count} ta xodim topshirgan. Savollarni o'zgartirsangiz, ularning eski ballari o'zgarmaydi.": "Этот тест прошли {result_count} сотрудников. Если изменить вопросы, их прежние баллы не изменятся.",

  // --- Foydalanuvchilar ---
  "Apparat xodimi": "Сотрудник аппарата",
  "Shahar-tuman: Inspektor": "Город/район: Инспектор",
  "Shahar-tuman: Katta inspektor": "Город/район: Старший инспектор",
  "Administrator": "Администратор",
  "Probatsiya xodimi": "Сотрудник пробации",
  "F.I.Sh va parol majburiy": "Ф.И.О. и пароль обязательны",
  "\"{fullName}\" qo'shildi. Kirish uchun: {badge_number} / {password}": "«{fullName}» добавлен. Для входа: {badge_number} / {password}",
  "  (loginni tizim berdi)": "  (логин выдан системой)",
  "Xodim qo'shilmadi. Qaytadan urinib ko'ring.": "Сотрудник не добавлен. Попробуйте ещё раз.",
  "\"{full_name}\" yangilandi. Yangi parol: {newPassword}": "«{full_name}» обновлён. Новый пароль: {newPassword}",
  "\"{full_name}\" ma'lumotlari yangilandi.": "Данные «{full_name}» обновлены.",
  "\"{full_name}\" faolsizlantirilsinmi?\n\nU ilovaga kira olmaydi, lekin test natijalari va nishonlari saqlanib qoladi.": "Деактивировать «{full_name}»?\n\nОн не сможет войти в приложение, но результаты тестов и значки сохранятся.",
  "\"{ism}\" qayta faollashtirildi.": "«{ism}» снова активирован.",
  "\"{ism}\" faolsizlantirildi.": "«{ism}» деактивирован.",
  "Yangi xodim qo'shish": "Добавить сотрудника",
  "Ism Familya *": "Имя Фамилия *",
  "Login (bo'sh qoldirsangiz o'zi beriladi)": "Логин (если оставить пустым, выдаётся автоматически)",
  "Parol * (kamida 6 belgi)": "Пароль * (не менее 6 символов)",
  "Tasodifiy parol yaratish": "Сгенерировать пароль",
  "Yaratish": "Создать",
  "Rol: {label}": "Роль: {label}",
  "Lavozimi: tanlanmagan (kunlik topshiriq ko'rinmaydi)": "Должность: не выбрана (ежедневные задачи не видны)",
  "Darajasi (masalan: Kapitan)": "Звание (например: Капитан)",
  "Bo'limi": "Отдел",
  "Ish joyi: biriktirilmagan": "Рабочее место: не назначено",
  "Ish joyi: {name}": "Рабочее место: {name}",
  "Tuman: biriktirilmagan (yig'ilishga kira olmaydi)": "Район: не назначен (не сможет войти на собрание)",
  "Tuman: {name}": "Район: {name}",
  "Probatsiya xodimiga tuman biriktirish shart — u faqat o'z tumani mahkumlarini ko'radi. Tumansiz reyestr ochilmaydi.": "Сотруднику пробации обязательно назначить район — он видит только осуждённых своего района. Без района реестр не откроется.",
  "Xodim mobil ilovaga shu login va parol bilan kiradi. Loginni o'zingiz o'ylab topmoqchi bo'lmasangiz bo'sh qoldiring — tizim keyingi bo'sh raqamni o'zi beradi va qo'shilgandan keyin sizga ko'rsatadi. Keyinroq tahrirlash orqali boshqasiga almashtirsangiz bo'ladi.": "Сотрудник входит в мобильное приложение с этим логином и паролем. Если не хотите придумывать логин, оставьте поле пустым — система выдаст следующий свободный номер и покажет его после добавления. Позже его можно изменить через редактирование.",
  "Ish joyi": "Рабочее место",
  "Rol": "Роль",
  "(siz)": "(вы)",
  "lavozimi belgilanmagan": "должность не назначена",
  "biriktirilmagan": "не назначено",
  "Faol emas": "Неактивен",
  "O'zingizni faolsizlantira olmaysiz": "Вы не можете деактивировать себя",
  "Faolsizlantirish": "Деактивировать",
  "Faollashtirish": "Активировать",
  "Xodimni tahrirlash": "Редактирование сотрудника",
  "Ism Familya": "Имя Фамилия",
  "Xodim ilovaga shu login bilan kiradi. Bo'sh qoldirsangiz o'zgarmaydi.": "Сотрудник входит в приложение с этим логином. Если оставить пустым, логин не изменится.",
  "Darajasi": "Звание",
  "O'z rolingizni o'zgartira olmaysiz": "Вы не можете изменить собственную роль",
  "Yangi parol (bo'sh qoldirsangiz o'zgarmaydi)": "Новый пароль (если оставить пустым, не изменится)",

  // --- Ish zonalari ---
  "Bino": "Здание",
  "Mahalla": "Махалля",
  "Tuman": "Район",
  "Shahar": "Город",
  "Bu matndan koordinata topilmadi. Havolani to'liq nusxalaganingizni tekshiring.": "В этом тексте координаты не найдены. Проверьте, что ссылка скопирована полностью.",
  "Bu qisqartirilgan havola — ichida koordinata yo'q. Uni brauzerda oching, ochilgan sahifaning to'liq manzilini nusxalab shu yerga qo'ying.": "Это сокращённая ссылка — в ней нет координат. Откройте её в браузере, скопируйте полный адрес открывшейся страницы и вставьте сюда.",
  "Koordinata olindi, lekin bu nuqta O'zbekistondan tashqarida. Kenglik va uzunlik o'rni almashib ketmaganini xaritadan tekshiring.": "Координаты получены, но эта точка за пределами Узбекистана. Проверьте по карте, не перепутаны ли широта и долгота.",
  "Koordinata olindi — xaritada belgilandi.": "Координаты получены — отмечено на карте.",
  "Zona nomi * (masalan: Bosh boshqarma)": "Название зоны * (например: Главное управление)",
  "Lokatsiya havolasini qo'ying": "Вставьте ссылку на локацию",
  "Telegramdagi lokatsiyani oching → havolani nusxalang → shu yerga qo'ying": "Откройте локацию в Telegram → скопируйте ссылку → вставьте сюда",
  "Google Maps, Yandex Xarita havolasi yoki oddiy «41.311081, 69.240562» ko'rinishidagi koordinata — barchasi bo'ladi.": "Подойдёт ссылка Google Maps, Яндекс Карт или координаты вида «41.311081, 69.240562».",
  "Kenglik / Latitude *": "Широта / Latitude *",
  "Uzunlik / Longitude *": "Долгота / Longitude *",
  "Radius (metr) *": "Радиус (метры) *",
  "{metr} metr": "{metr} м",
  "Faol (o'chirilsa hisobga olinmaydi)": "Активна (если выключить, не учитывается)",
  "Zona nomini kiriting": "Введите название зоны",
  "Kenglikni to'g'ri kiriting": "Введите корректную широту",
  "Uzunlikni to'g'ri kiriting": "Введите корректную долготу",
  "Radiusni to'g'ri kiriting": "Введите корректный радиус",
  "Zona qo'shilmadi.": "Зона не добавлена.",
  "Zona yangilandi.": "Зона обновлена.",
  "\"{name}\" zonasi o'chirilsinmi?": "Удалить зону «{name}»?",
  "Zona o'chirildi.": "Зона удалена.",
  "Xodim belgilanganda shu doiralardan biri ichida bo'lsa — \"ish joyida\", aks holda \"zona tashqarida\" hisoblanadi.": "Если при отметке сотрудник внутри одного из этих кругов — «на рабочем месте», иначе — «вне зоны».",
  "Yangi zona": "Новая зона",
  "Radius haqida:": "О радиусе:",
  "bino uchun": "для здания рекомендуется",
  "150–250 metr": "150–250 метров",
  "tavsiya etiladi. Juda kichik qilsangiz (masalan 50 m), telefon GPS'ining tabiiy xatoligi (10–50 m) sababli xodim binoda turib ham \"tashqarida\" chiqishi mumkin.": "— если сделать слишком маленьким (например, 50 м), из-за естественной погрешности GPS телефона (10–50 м) сотрудник может оказаться «вне зоны», находясь в здании.",
  "Butun tumanni qamrash uchun 5 km yoki undan katta radius ham qo'ysa bo'ladi, lekin unda nazorat susayadi: xodim o'sha tuman ichidagi uyida turib ham \"ish joyida\" deb belgilanaveradi.": "Для охвата всего района можно задать радиус 5 км и больше, но контроль ослабнет: сотрудник сможет отмечаться «на рабочем месте», находясь дома в этом районе.",
  "Koordinata": "Координаты",
  "Radius": "Радиус",
  "Hali zona qo'shilmagan. Zona bo'lmasa, barcha belgilanishlar \"zona tashqarida\" ko'rinadi.": "Зон пока нет. Без зон все отметки будут отображаться как «вне зоны».",
  "Zonani tahrirlash": "Редактирование зоны",

  // --- Xaritadan zona tanlash ---
  "Brauzer joylashuvni qo'llab-quvvatlamaydi": "Браузер не поддерживает геолокацию",
  "Joylashuvni aniqlab bo'lmadi. Brauzerda ruxsat berganingizni tekshiring.": "Не удалось определить местоположение. Проверьте, что в браузере дано разрешение.",
  "Xaritada ish joyini bosing — koordinata avtomatik olinadi": "Нажмите на карте рабочее место — координаты подставятся автоматически",
  "Aniqlanmoqda...": "Определение...",
  "📍 Men shu yerdaman": "📍 Я здесь",
  "Tanlangan:": "Выбрано:",
  "yashil doira —": "зелёный круг —",
  "m radius": "м радиус",
  // Mas'ul inspektor, xodim almashtirish, qidiruv, ilova versiyalari
  "Ilova versiyalari": "Версии приложения",
  "Universal — barcha telefonlar": "Универсальный — для всех телефонов",
  "arm64-v8a — zamonaviy telefonlar": "arm64-v8a — современные телефоны",
  "armeabi-v7a — eski 32 bitli telefonlar": "armeabi-v7a — старые 32-битные телефоны",
  "APK faylni tanlang": "Выберите APK-файл",
  "Versiya 1.4.0 ko'rinishida bo'lsin": "Версия должна быть в виде 1.4.0",
  "Majburiy versiya: undan eski ilovalar ishlamay qoladi va xodimlar yangilashga majbur bo'ladi. Davom etilsinmi?": "Обязательная версия: более старые приложения перестанут работать, и сотрудникам придётся обновиться. Продолжить?",
  "{versiya} ({abi}) yuklandi.": "{versiya} ({abi}) загружена.",
  "Fayl yuklanmadi. Qaytadan urinib ko'ring.": "Файл не загружен. Попробуйте ещё раз.",
  "Manguberdi ilovasining yangi APK faylini shu yerga yuklang — xodimlarning ilovasi uni o'zi topadi. Fayl faqat tizimga kirgan xodimga beriladi.": "Загрузите сюда новый APK-файл приложения Manguberdi — приложение сотрудников найдёт его само. Файл выдаётся только сотрудникам, вошедшим в систему.",
  "Oxirgi build": "Последняя сборка",
  "Eng kam ruxsat etilgan build": "Минимальная допустимая сборка",
  "Undan eskisi ishlamaydi": "Более старые не работают",
  "Yangi versiya yuklash": "Загрузить новую версию",
  "APK fayl": "APK-файл",
  "Versiya, masalan 1.4.0": "Версия, например 1.4.0",
  "Build raqami, masalan 14": "Номер сборки, например 14",
  "Protsessor turi": "Тип процессора",
  "Nima yangilik (xodimlarga ko'rsatiladi)": "Что нового (показывается сотрудникам)",
  "Majburiy yangilash": "Обязательное обновление",
  "Xavfsizlik tuzatishi yoki server o'zgarishi bo'lsa belgilang. Undan eski ilova hech narsa ochmaydi — faqat yangilash oynasi chiqadi.": "Отметьте при исправлении безопасности или изменениях на сервере. Более старое приложение ничего не откроет — будет показано только окно обновления.",
  "Versiya va build pubspec.yaml dagi \"version: 1.4.0+14\" qatoridan olinadi: 1.4.0 — versiya, 14 — build. Har yangi versiyada build kattalashishi shart.": "Версия и сборка берутся из строки \"version: 1.4.0+14\" в pubspec.yaml: 1.4.0 — версия, 14 — сборка. В каждой новой версии номер сборки должен увеличиваться.",
  "Yuklanmoqda... {foiz}%": "Загрузка... {foiz}%",
  "Yuklash": "Загрузить",
  "Yuklangan versiyalar": "Загруженные версии",
  "Hali versiya yuklanmagan": "Версии ещё не загружены",
  "majburiy": "обязательная",
  "Majburiylikni olib tashlash": "Снять обязательность",
  "Majburiy qilish": "Сделать обязательной",
  "Bu fayl qaytarib olinsinmi? Xodimlarga boshqa taklif qilinmaydi.": "Отозвать этот файл? Сотрудникам он больше не будет предлагаться.",
  "Qaytarib olish": "Отозвать",
  "Qayta faollashtirish": "Вернуть",
  "Inspektorni tanlang": "Выберите инспектора",
  "Mas'ul inspektor:": "Ответственный инспектор:",
  "O'zgartirish": "Изменить",
  "Tarixni yopish": "Скрыть историю",
  "Yangi inspektor": "Новый инспектор",
  "Yangi inspektorni tanlang": "Выберите нового инспектора",
  "{soni} ta mahkum": "осуждённых: {soni}",
  "Sabab (ixtiyoriy)": "Причина (необязательно)",
  "Tarix bo'sh": "История пуста",
  "hozirgacha": "по настоящее время",
  "kiritdi: {ism}": "внёс: {ism}",
  "Qidirib bo'lmadi.": "Не удалось выполнить поиск.",
  "Barcha tumanlardan qidirish": "Поиск по всем районам",
  "Familiya, ism yoki JSHSHIR": "Фамилия, имя или ПИНФЛ",
  "JK moddasi (masalan 169)": "Статья УК (например, 169)",
  "Barcha tumanlar": "Все районы",
  "{jami} ta topildi, birinchi {soni} tasi ko'rsatilgan": "Найдено: {jami}, показаны первые {soni}",
  "{jami} ta topildi": "Найдено: {jami}",
  "Inspektor biriktirilmagan": "Инспектор не назначен",
  "Mas'ul inspektor": "Ответственный инспектор",
  "Biriktirilmagan": "Не назначен",
  "Men (kirituvchi)": "Я (кто вносит)",
  "Barcha inspektorlar": "Все инспекторы",
  "Mas'ul inspektor o'zgartirildi.": "Ответственный инспектор изменён.",
  "{mahkum} ta mahkum, {sud} ta sayyor sud.": "Осуждённых: {mahkum}, выездных судов: {sud}.",
  "Almashtirish sababini yozing": "Укажите причину замены",
  "\"{ism}\" faolsizlantiriladi va tizimga kira olmaydi. Davom etilsinmi?": "«{ism}» будет деактивирован(а) и не сможет войти в систему. Продолжить?",
  "{eski} → {yangi}: {mahkum} ta mahkum va {sud} ta sayyor sud o'tkazildi.": "{eski} → {yangi}: передано осуждённых — {mahkum}, выездных судов — {sud}.",
  "Xodim faolsizlantirildi.": "Сотрудник деактивирован.",
  "Mahkumlari va rejadagi sayyor sudlarini boshqa inspektorga o'tkazish": "Передать его осуждённых и запланированные выездные суды другому инспектору",
  "Almashtirish": "Замена",
  "Xodim almashtirishlar tarixi": "История замен сотрудников",
  "Ko'rsatish": "Показать",
  "Hali almashtirish bo'lmagan": "Замен ещё не было",
  "Kimdan → kimga": "От кого → кому",
  "Sabab": "Причина",
  "Kim bajardi": "Кто выполнил",
  "eski xodim faolsizlantirildi": "прежний сотрудник деактивирован",
  "Xodimni almashtirish": "Замена сотрудника",
  "Yangi inspektorga o'tadi:": "Перейдёт к новому инспектору:",
  "Kim qachon mas'ul bo'lgani o'chirilmaydi. O'tkazilib bo'lgan sayyor sudlar o'zgarmaydi.": "История ответственности не удаляется. Уже проведённые выездные суды не меняются.",
  "Bu tumanda boshqa faol probatsiya xodimi yo'q. Avval yangi xodimni qo'shing.": "В этом районе нет другого действующего сотрудника пробации. Сначала добавьте нового сотрудника.",
  "Sabab * (masalan: boshqa ishga o'tdi, buyruq №…)": "Причина * (например: перешёл на другую работу, приказ №…)",
  "Eski xodimni faolsizlantirish": "Деактивировать прежнего сотрудника",
  "Ishdan ketgan bo'lsa belgilang: tizimga kira olmaydi, telefoniga bildirishnoma bormaydi.": "Отметьте, если сотрудник уволился: он не сможет войти в систему, уведомления на его телефон приходить не будут.",
  "Mahkumlarni boshqa inspektorga o'tkazish": "Передать осуждённых другому инспектору",
  "Manguberdi (xodimlar)": "Manguberdi (сотрудники)",
  "prob24 (mahkumlar)": "prob24 (осуждённые)",
  "prob24 ning yangi APK faylini shu yerga yuklang — mahkum ilovasi uni o'zi topadi. Fayl faqat biriktirilgan qurilmaga beriladi. Majburiy versiya ham signal yuborishni to'xtatmaydi — ilova mahkumdan yangilashni so'rab turadi.": "Загрузите сюда новый APK-файл prob24 — приложение осуждённого найдёт его само. Файл выдаётся только привязанному устройству. Даже обязательная версия не останавливает отправку сигналов — приложение будет просить осуждённого обновиться.",
  "Ilova": "Приложение",
  "Qurilmani uzish": "Отвязать устройство",
  "Telefon almashtirilsa yoki ilova qayta o'rnatilsa": "Если телефон заменён или приложение переустановлено",
  "{familiya} {ism} telefoni nazoratdan uzilsinmi?\n\nSignal kelmay qoladi. Yangi telefon ulash uchun \"Ilova kodi\" tugmasi bilan yangi kod berasiz.": "Отвязать телефон {familiya} {ism} от контроля?\n\nСигналы перестанут поступать. Чтобы подключить новый телефон, выдайте новый код кнопкой \"Код приложения\".",
  "Qurilma biriktiruvi bekor qilindi": "Привязка устройства отменена",
  "Tahlil": "Анализ",
  "Viloyat kesimida oylik ko'rsatkichlar. Tumanni tanlab, faqat o'sha tumanni ko'rish mumkin.": "Ежемесячные показатели по области. Выбрав район, можно смотреть только его.",
  "O'z tumaningiz bo'yicha oylik ko'rsatkichlar.": "Ежемесячные показатели по вашему району.",
  "Ma'lumot {oy} holatiga": "Данные за {oy}",
  "Hisobda turgan shaxslar": "Лица, состоящие на учёте",
  "Ilova ulangan": "Приложение подключено",
  "Ilovasiz qolgan": "Без приложения",
  "Tashrif normasi bajarilishi": "Выполнение нормы посещений",
  "Faqat jismoniy tashrif hisoblanadi (403-son buyruq, 84–85-bandlar). Onlayn va telefon tekshiruvi qo'shimcha nazorat.": "Учитывается только личное посещение (приказ № 403, пункты 84–85). Онлайн- и телефонная проверка — дополнительный контроль.",
  "{bajarildi} ta tashrif / {kerak} ta kerak": "{bajarildi} посещений из {kerak} требуемых",
  "Bu oyda bir marta ham borilmagan": "Ни разу не посещены в этом месяце",
  "Shaxslar": "Лица",
  "Oyiga kerak": "Требуется в месяц",
  "Asos": "Основание",
  "So'nggi 6 oy dinamikasi": "Динамика за последние 6 месяцев",
  "Oy ichidagi tekshiruvlar": "Проверки за месяц",
  "Bu oyda tekshiruv o'tkazilmagan.": "В этом месяце проверок не проводилось.",
  "Soni": "Количество",
  "Ogohlantirish sabablari": "Причины предупреждений",
  "Bu oyda ogohlantirish bo'lmagan.": "В этом месяце предупреждений не было.",
  "Tumanlar kesimi": "В разрезе районов",
  "Inspektorlar yuklamasi": "Нагрузка инспекторов",
  "Mahkumlar soni va shu oyda o'tkazilgan tashriflar.": "Количество осуждённых и проведённые в этом месяце посещения.",
  "Inspektor topilmadi.": "Инспектор не найден.",
  "Prokuror xabarnomalari": "Уведомления прокурору",
  "O'RQ-938 24-moddasi: mahkum uyiga kirilgani haqida 24 soat ichida xabar beriladi.": "Статья 24 ЗРУ-938: о посещении жилища осуждённого сообщается в течение 24 часов.",
  "Yuborilgan": "Отправлено",
  "Muddati o'tgan": "Просрочено",
  "Sayyor sudlar": "Выездные суды",
  "Onlayn va telefon": "Онлайн и телефон",
  "Oy": "Месяц",
  "Ozodlikni cheklash jazosida": "На ограничении свободы",
  "Rejim": "Режим",
  "OChJ": "ОСН",
  "Mahkumlar": "Осуждённые",
  "Kutilmoqda": "Ожидается",
  "Yakunlangan": "Завершено",
  "Kenglik va uzunlik o'rni almashib ketganga o'xshaydi: bu nuqta O'zbekistondan tashqarida, almashtirilsa — ichida.": "Похоже, широта и долгота перепутаны местами: эта точка вне Узбекистана, а при перестановке — внутри.",
  "Almashtirib qo'yish": "Поменять местами",
  "Bu nuqta O'zbekistondan tashqarida. Xaritadan tekshiring — koordinata xato bo'lsa, davomat hech qachon \"ish joyida\" deb belgilanmaydi.": "Эта точка вне Узбекистана. Проверьте по карте: при неверных координатах отметка никогда не будет засчитана как «на рабочем месте».",
  "Kenglik va uzunlik o'rni almashib ketganga o'xshaydi — bu nuqta O'zbekistondan tashqarida.\n\nBaribir saqlansinmi?": "Похоже, широта и долгота перепутаны местами — точка вне Узбекистана.\n\nВсё равно сохранить?",
  "Bu nuqta O'zbekistondan tashqarida.\n\nBaribir saqlansinmi?": "Эта точка вне Узбекистана.\n\nВсё равно сохранить?",
  "koordinata almashgan": "координаты перепутаны",
  "O'zbekistondan tashqarida": "вне Узбекистана",
  "Sayyor sud surati": "Фото выездного суда",
  "Olingan vaqti: {vaqt}": "Время съёмки: {vaqt}",
  "Olingan vaqti qayd etilmagan": "Время съёмки не зафиксировано",
  "Joylashuvi: {lat}, {lon}": "Местоположение: {lat}, {lon}",
  "Joylashuv qayd etilmagan": "Местоположение не зафиксировано",
  "Fayl izi (SHA-256): {xesh}": "Отпечаток файла (SHA-256): {xesh}",
  "Surat yuborilmagan — bu sud dalilsiz qolgan.": "Фото не отправлены — это заседание осталось без подтверждения.",
  "Suratlar ({soni} ta) — olingan zahoti serverga yuborilgan": "Фото ({soni} шт.) — отправлены на сервер сразу при съёмке",
  "{raqam}-surat": "Фото {raqam}",
  "vaqtsiz": "без времени",
  "GPSsiz": "без GPS",
  "SOXTA GPS": "ПОДДЕЛЬНЫЙ GPS",
  "{masofa} m narida": "в {masofa} м от точки",
  "tayanch nuqta": "опорная точка",
  "Suratlar serverda saqlanadi: har biri olingan vaqti va joylashuvi bilan. To'liq nusxasi inspektor telefonidagi ma'lumotnomada ham bor.": "Фото хранятся на сервере: каждое со временем съёмки и местоположением. Полная копия также в справке на телефоне инспектора.",
  "Topshiriq:": "Задание:",
  "surat shunga mos kelishi kerak": "фото должно соответствовать ему",
  "Orqa kameradan olingan — boshqa ekranni suratga olgan bo'lishi mumkin": "Снято основной камерой — возможно, сфотографирован чужой экран",
  "Old kameradan": "С фронтальной камеры",
  "Kamera turi noma'lum": "Тип камеры неизвестен",
  "olingan {vaqt}": "снято в {vaqt}",
  "olingan vaqti qayd etilmagan": "время съёмки не зафиксировано",
  "Hali selfi kelmagan. Onlayn tekshiruv yuborilganda bu yerda kunlar bo'yicha saqlanadi.": "Селфи пока не поступали. Они будут храниться здесь по дням после онлайн-проверки.",
  "{soni} ta selfi": "{soni} селфи",
  "Selfi": "Селфи",
  "orqa kamera": "основная камера",
  "Ro'yxat": "Список",
  "Selfilar": "Селфи",
  "Onlayn tekshiruv selfilari kunlar bo'yicha saqlanadi. Qizil ramka — shubhali surat (orqa kamera yoki vaqti qayd etilmagan).": "Селфи онлайн-проверок хранятся по дням. Красная рамка — подозрительное фото (основная камера или время не зафиксировано).",
  "Nazoratda": "На контроле",
  "Ilovasiz": "Без приложения",
  "Signallar": "Сигналы",
  "Uydan chiqish": "Выход из дома",
  "{soni} ta tekshiruv": "{soni} проверок",
  "oxirgisi {vaqt}": "последняя {vaqt}",
  "{soni} buzilish": "{soni} нарушений",
  "Nazorat vaqti (hukmda ko'rsatilgan)": "Время контроля (указано в приговоре)",
  "Hukmda odatda aniq soat yoziladi — masalan 22:00 dan 06:00 gacha uy-joyda bo'lish. Shu vaqtdan tashqarida uydan chiqish buzilish hisoblanmaydi: mahkum ish yoki o'qishda bo'ladi.":
    "В приговоре обычно указывается точное время — например, находиться дома с 22:00 до 06:00. Выход из дома вне этого времени нарушением не считается: осуждённый находится на работе или учёбе.",
  "Soat ... dan": "С часа",
  "... gacha": "До",
  "Nazorat: {dan} dan {gacha} gacha. Qolgan vaqtda uydan chiqish taqiqlanmaydi.":
    "Контроль: с {dan} до {gacha}. В остальное время выход из дома не запрещён.",
  "Vaqt ko'rsatilmagan — nazorat kecha-kunduz davom etadi va kunduzi ishdagi mahkum ham buzuvchi deb belgilanadi.":
    "Время не указано — контроль ведётся круглосуточно, и осуждённый, находящийся днём на работе, тоже будет отмечен как нарушитель.",
  " · nazorat {dan}–{gacha}": " · контроль {dan}–{gacha}",
  " · nazorat kecha-kunduz": " · контроль круглосуточно",
  "Aloqa uzilishi": "Потеря связи",
  "GPS/ruxsat": "GPS/разрешение",
  "Masofaviy nazorat — kunlik hisobot": "Дистанционный контроль — суточный отчёт",
  "Kunlik hisobot": "Суточный отчёт",
  "Masofaviy nazorat bo'yicha kun yakuni. Raqamlar bazadan avtomatik olinadi — qo'lda to'ldirish shart emas.": "Итоги суток по дистанционному контролю. Цифры берутся из базы автоматически — заполнять вручную не нужно.",
  "Chop etish / PDF": "Печать / PDF",
  "Word (.doc)": "Word (.doc)",
  "Kun yakunida saqlangan — raqamlar o'zgarmaydi": "Сохранено на конец суток — цифры не меняются",
  "Jonli hisob — kun hali tugamagan": "Текущий расчёт — сутки ещё не завершены",
  "Sana: {sana}": "Дата: {sana}",
  "Ozodlikni cheklash jazosi · O'RQ-938, 403-son buyruq 84–85-band": "Наказание в виде ограничения свободы · ЗРУ-938, приказ № 403, пункты 84–85",
  "Norma": "Норма",
  "JAMI": "ИТОГО",
  "Norma — oy boshidan hisoblangan jismoniy tashriflar (403-son buyruq, 84–85-bandlar). Onlayn va telefon tekshiruvi normani to'ldirmaydi.": "Норма — личные посещения с начала месяца (приказ № 403, пункты 84–85). Онлайн- и телефонная проверка норму не закрывают.",
  "Hisobotda faqat o'z tumaningiz ma'lumoti ko'rsatilgan.": "В отчёте показаны данные только вашего района.",
  "Universal fayl mavjud o'rnatmalar ustiga tushishi uchun u \"--build-number=3000+build\" bilan yig'ilgan bo'lishi kerak (masalan build 35 uchun 3035). Bu yerga esa oddiy raqam — 35 — yoziladi.":
    "Чтобы универсальный файл устанавливался поверх уже установленных, он должен быть собран с \"--build-number=3000+build\" (например, 3035 для сборки 35). Здесь же указывается обычный номер — 35.",
  "Odatda bitta universal fayl yetarli — u barcha telefonlarga tushadi. Protsessor bo'yicha alohida fayllar faqat yuklab olish hajmini kichraytirish kerak bo'lganda yuklanadi; ularni bir xil versiya va build bilan yuboring.":
    "Обычно достаточно одного универсального файла — он устанавливается на все телефоны. Отдельные файлы по процессору нужны только для уменьшения размера загрузки; отправляйте их с одинаковой версией и сборкой.",
  "Diqqat: bu majburiy versiyada barcha telefonlar uchun fayl yo'q. Universal faylni yuklang — aks holda ba'zi xodimlar ilovani yangilay olmaydi.":
    "Внимание: в этой обязательной версии нет файла для всех телефонов. Загрузите универсальный файл — иначе часть сотрудников не сможет обновить приложение.",
  // Uyga yo'l — navigator havolalari.
  "Uyga yo'l": "Маршрут до дома",
  "Yo'l": "Маршрут",
  "Uyga boradigan yo'lni navigatorda ochadi": "Откроет маршрут до дома в навигаторе",
  "Manzil ko'rsatilmagan": "Адрес не указан",
  "Nusxalash": "Копировать",
  "Nusxalandi": "Скопировано",
  "Uy koordinatasi ko'rsatilmagan — xarita faqat manzil matni bo'yicha qidiradi va aniq bo'lmasligi mumkin.":
    "Координаты дома не указаны — карта ищет только по тексту адреса и может ошибаться.",
  "Yandex navigatorda ochish": "Открыть в Яндекс Навигаторе",
  "Google xaritada ochish": "Открыть в Google Картах",
  "Telefonda havola navigator ilovasini o'zi ochadi. Kompyuterda koordinatani nusxalab telefonga yuboring.":
    "На телефоне ссылка сама откроет навигатор. На компьютере скопируйте координаты и отправьте на телефон.",

  // Mahkumning yordam so'rovi (prob24 SOS tugmasi).
  "Tibbiy yordam kerak": "Нужна медицинская помощь",
  "Xavfsizlikka tahdid": "Угроза безопасности",
  "Boshqa sabab": "Другая причина",
  "Nima qilindi? (yakunlash uchun majburiy)": "Что было сделано? (обязательно для завершения)",
  "YORDAM SO'RALDI": "ЗАПРОШЕНА ПОМОЩЬ",
  "Sabab ko'rsatilmagan": "Причина не указана",
  " · uydan {masofa} m": " · от дома {masofa} м",
  "joylashuv yo'q": "местоположение недоступно",
  "Qabul qilindi": "Принято",
  "Qabul qildim": "Принял",
};

export default lugat;
